var isClient = typeof document !== "undefined";
export default isClient;